/**
 * Splits the url around the installationId-part and inserts the storageId inbetween
 */
export const buildNavigationUrl = (path: string, installationId: string, storageId: string | number, search: string): string => {
  if (!installationId) return path

  const split = path.split(`/${installationId}`) || []
  const prefixPath = split[0] ?? path
  const suffixPath = split[1] ?? ''

  return `${prefixPath}/${installationId}/${storageId}${suffixPath}${search}`
}

/**
 * Normalize a path by removing duplicate and trailing slashes.
 */
export const normalizePath = (path: string): string => {
  const trimmedPath = path.trim()

  if (!trimmedPath || trimmedPath === '/') {
    return '/'
  }

  const segments = trimmedPath.split('/').filter(Boolean)
  return `/${segments.join('/')}`
}
